import { useState, type ReactNode } from 'react';

/**
 * 報告完成後，把「執行過程型資訊」（候選店家 / 商家公開資料 / 同業樣本與統計）
 * 收合成預設 collapsed 的區塊（Batch 6-B2.1）。
 * 只做收合，不刪除資料；健診進行中的流程完全不變（此元件僅在報告完成後使用）。
 */
export default function ExecutionDetailsSection({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="ds-container pt-10">
        <div className="rounded-2xl border border-background-300 bg-background-100">
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-5 text-left"
          >
            <span className="flex min-w-0 items-center gap-3.5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-background-50 text-primary-700 ring-1 ring-background-300">
                <i className="ri-history-line text-xl" />
              </span>
              <span className="min-w-0">
                <span className="block text-base font-bold text-foreground-900">
                  查看本次健診資料與同業樣本
                </span>
                <span className="mt-1 block text-sm text-foreground-500">
                  候選店家、商家公開資料、同業樣本與統計
                </span>
              </span>
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-foreground-600">
              {open ? '收合' : '展開'}
              <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-xl text-foreground-400`} />
            </span>
          </button>
        </div>
      </section>

      {open && <div>{children}</div>}
    </>
  );
}